// extracted by mini-css-extract-plugin
export default {"footer":"home_footer__lJ699","stateString":"home_stateString__rdy91","content":"home_content__mxz+Z","sidebar":"home_sidebar__mX4BK","feed":"home_feed__TpLmP"};